<template>
  <div class="mt-4">
    <h4>{{ $t('message.yourDetails') }}</h4>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label class="required" for="First Name">{{ $t('message.firstName') }}</label>
        <input
          v-validate="'required|min:2'"
          id="FirstName"
          v-model="editModel.FirstName"
          @change="syncFirstName(editModel.FirstName)"
          name="firstName"
          type="text"
          class="form-control"
        />
        <div
          class="invalid-feedback"
        >{{ OOErrors.first("firstName") | inputNameLocale("firstName") }}</div>
      </div>
      <div class="form-group col-md-6">
        <label class="required" for="Last Name">{{ $t('message.lastName') }}</label>
        <input
          v-validate="'required|min:2'"
          id="LastName"
          v-model="editModel.LastName"
          name="lastName"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("lastName") | inputNameLocale("lastName") }}</div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <label class="required" for="EmailAddress">{{ $t('message.email') }}</label>
        <input
          @change="checkEmailExistance(editModel.Email)"
          @load="checkEmailExistance(editModel.Email)"
          @blur="checkEmailExistance(editModel.Email)"
          @keydown="userIsExist=false"
          v-validate="'required|email'"
          id="EmailAddress"
          v-model="editModel.Email"
          name="email"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("email") | inputNameLocale("email")}}</div>
      </div>
      <div class="form-group col-md-6">
        <label class="required" for="Phone Number">{{ $t('message.phoneNumber') }}</label>
        <input
          v-validate="{ required: true, min: 8, regex: this.getRegex(), max: this.getMax()}"
          id="Phone Number"
          v-model="editModel.Phone"
          name="phoneNumber"
          type="text"
          class="form-control"
        />
        <div
          class="invalid-feedback"
        >{{ OOErrors.first("phoneNumber") | inputNameLocale("phoneNumber")}}</div>
      </div>
    </div>
    <div v-if="viewConfig.LogIn && !user && !forGift" class="form-row">
      <div class="form-group col-md-12">
        <div class="custom-control custom-checkbox col-md-12 ml-12">
          <input
            id="newAccount"
            type="checkbox"
            name="customCheckbox"
            :checked="createNewAccount"
            @change="check"
            class="custom-control-input"
            @input="val => $emit('save-user', val.target.checked)"
          />
          <label class="custom-control-label" for="newAccount">
            {{ $t('message.registerNewAccount') }}
            <small
              class="light-text d-block"
            >{{ $t('message.placingOrderAsGuest') }}</small>
          </label>
        </div>
      </div>
      <div class="form-group col-md-12">
        <div v-if="createNewAccount && userIsExist">
          {{ $t('message.alreadyAccountForEmail') }}
          <router-link
            class="text-primary"
            :to="{ name: 'login', params: { storeid: $parent.storeid ,forgift: forGift }}"
          >{{ $t('message.login') }}</router-link>&nbsp;here.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { userIsExist } from "../../../../api/services/userService";
export default {
  name: "MyDetail",
  props: {
    editModel: {
      type: Object,
      default: () => {}
    },
    chargeToRoom: {
      type: Boolean,
      default: false
    },
    forGift: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userIsExist: false,
      createNewAccount: false
    };
  },
  computed: {
    ...mapGetters(["user","viewConfig", "getTotalPrice", "getRecentOrder", "selectedCompany"])
  },
  mounted() {
    this.checkEmailExistance(this.editModel.Email);
    var lastOrder = this.getRecentOrder(this.$route.params.storeid);
    if (lastOrder) {
      this.editModel.Phone = lastOrder.ContactCustomer_Contact_Number;
      this.editModel.Email = lastOrder.ContactCustomer_Email_Address;
      this.editModel.FirstName = lastOrder.ContactCustomer_FirstName;
      this.editModel.LastName = lastOrder.ContactCustomer_LastName;
    }
  },
  methods: {
    getMax(){
      let country = this.selectedCompany.Location.Country;
      return country == "AU" ? 10:15
    },
    getRegex(){
      let country = this.selectedCompany.Location.Country;
      return country == "AU" ? /04\d{8}/:/\d/
    },
    syncFirstName(firstName) {
      if (this.$parent.syncFirstName) this.$parent.syncFirstName(firstName);
    },
    validate() {
      return this.$validator.validateAll();
    },
    checkEmailExistance(email) {
      userIsExist(email)
        .then(result => {
          if (result.length > 0) {
            this.$parent.setUserIsExist(true);
            this.userIsExist = true;
          } else {
            this.$parent.setUserIsExist(false);
            this.userIsExist = false;
          }
        })
        .catch(() => {
          this.$parent.setUserIsExist(false);
          this.userIsExist = false;
        });
    },
    check: function(event) {
      this.createNewAccount = event.target.checked;
    },
    setRegisterNewUserState(state) {
      this.createNewAccount = state;
    }
  }
};
</script>
